import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import Action from './Modules.Action.record';
import { Form, Row, Col, Select, Input, DatePicker, Button, Checkbox, InputNumber, Radio } from 'antd';
import moment from 'moment';
import Language from 'kts-platform-frame/entry/Language';
import { TransformType, Transformtypenum } from 'kts-platform-frame/entry/constant';
const css = require('./index.scss');
const FormItem = Form.Item;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    getData: () => void;
}

/**  */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class AuthRecordFilter extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    onChange = () => {

    }
    render() {
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 }
        };
        const { form: { getFieldDecorator } } = this.props;
        const ocrStateOption = [
            { label: '识别中', value: 0 },
            { label: '未识别', value: 1 },
            { label: '识别成功', value: 2 },
        ];
        const draftStatesOption = [
            { label: '未处理', value: 0 },
            { label: '勾选失败', value: 1 },
            { label: '勾选成功', value: 2 },
        ];
        const inputTypesOption = [
            { label: '扫描枪', value: 1 },
            { label: '扫描仪', value: 2 },
            { label: '手工', value: 3 },
            { label: 'excel上传', value: 4 },
            { label: '影像文件', value: 5 },
            { label: 'api录入', value: 6 },
        ];
        const excelParseOption = [
            { label: '全部', value: undefined },
            { label: '解析成功', value: 0 },
            { label: '解析失败', value: 1 },
        ];
        const invoiceTypeOption = [
            { label: Language.transformTypeStringShort(TransformType.增值税专用发票), value: Transformtypenum.增值税专用发票 },
            { label: Language.transformTypeStringShort(TransformType.增值税普通发票INVOICE), value: Transformtypenum.增值税普通发票INVOICE },
            { label: Language.transformTypeStringShort(TransformType.机动车销售统一发票), value: Transformtypenum.机动车销售统一发票 },
            { label: Language.transformTypeStringShort(TransformType.增值税电子普通发票), value: Transformtypenum.增值税电子普通发票 },
            { label: Language.transformTypeStringShort(TransformType.增值税普通发票卷票), value: Transformtypenum.增值税普通发票卷票 },
            { label: Language.transformTypeStringShort(TransformType.通行费发票), value: Transformtypenum.通行费发票 },
        ];
        let filter = this.modulesState.loggingFilter;
        return (
            <div style={{ padding: 10 }}>
                <Form onSubmit={this.handleFilter} >
                    <FormItem label={`发票代码`} {...formItemLayout}>
                        {getFieldDecorator('invoiceCode', {
                            rules: [
                                {
                                    message: '请输入号码（只支持数字)',
                                    pattern: /^[0-9]*$/,
                                }
                            ],
                            initialValue: filter && filter.invoiceCode
                        })(
                            <Input
                                type="text"
                                placeholder="10位或12位发票码"
                                maxLength={12}
                            />
                        )}
                    </FormItem>
                    <FormItem label={`发票号码`} {...formItemLayout}>
                        {getFieldDecorator('invoiceNumber', {
                            rules: [
                                {
                                    message: '请输入号码（只支持数字)',
                                    pattern: /^[0-9]*$/,
                                }
                            ],
                            initialValue: filter && filter.invoiceNumber
                        })(
                            <Input
                                type="text"
                                placeholder="8位发票号码"
                                maxLength={8}
                            />
                        )}
                    </FormItem>
                    <FormItem label={`文件名`} {...formItemLayout}>
                        {getFieldDecorator('orgFileName', {
                            initialValue: filter && filter.orgFileName
                        })(
                            <Input
                                type="text"
                                placeholder="输入文件名"
                            />
                        )}
                    </FormItem>
                    {/* <FormItem label={`开票日期`} {...formItemLayout}>
                        <Col span={11}>
                            <FormItem>
                                {getFieldDecorator('minInvoiceDate', {
                                    initialValue: filter && filter.minInvoiceDate
                                })(
                                    <DatePicker />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={2}>
                            <span
                                style={{
                                    display: 'inline-block',
                                    width: '100%',
                                    textAlign: 'center'
                                }}
                            >
                                -
                            </span>
                        </Col>
                        <Col span={11}>
                            <FormItem>
                                {getFieldDecorator('maxInvoiceDate', {
                                    initialValue: filter && filter.maxInvoiceDate
                                })(
                                    <DatePicker />
                                )}
                            </FormItem>
                        </Col>
                    </FormItem>
                    <FormItem label="无税金额" {...formItemLayout} >
                        <Col span={11}>
                            <FormItem>
                                {getFieldDecorator('minAmountWithoutTax', {
                                    initialValue: filter && filter.minAmountWithoutTax
                                })(
                                    <InputNumber style={{ width: '100%' }} precision={2} />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={2}>
                            <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                -
                            </span>
                        </Col>
                        <Col span={11}>
                            <FormItem>
                                {getFieldDecorator('maxAmountWithoutTax', {
                                    initialValue: filter && filter.maxAmountWithoutTax
                                })(
                                    <InputNumber style={{ width: '100%' }} precision={2} />
                                )}
                            </FormItem>
                        </Col>
                    </FormItem> */}
                    {/* <FormItem label="发票类型" {...formItemLayout} >
                        {getFieldDecorator('invoiceTypes', {
                            initialValue: filter && filter.invoiceTypes
                        })(
                            <Select mode="multiple" >
                                {invoiceTypeOption.map(d => <Option value={Number(d.value)} key={d.value}>{d.label}</Option>)}
                            </Select>
                        )}
                    </FormItem> */}

                    <FormItem {...formItemLayout} label={`解析状态`}>
                        {getFieldDecorator('erpExcelParseResult', {
                            initialValue: filter && filter.erpExcelParseResult
                        })(
                            <Radio.Group >
                                <Radio value={null}>全部</Radio>
                                <Radio value={'2'}>解析成功</Radio>
                                <Radio value={'1'}>解析失败</Radio>
                            </Radio.Group>
                        )}
                    </FormItem>
                    <FormItem label="录入用户" {...formItemLayout} >
                        {getFieldDecorator('userType', {
                            initialValue: filter && filter.userType
                        })(
                            <Radio.Group >
                                <Radio value={null}>全部用户</Radio>
                                <Radio value={1}>当前用户</Radio>
                            </Radio.Group>
                        )}
                    </FormItem>


                    <FormItem
                        label="录入时间"
                        {...formItemLayout}
                    >
                        <Col span={11}>
                            <FormItem>
                                {getFieldDecorator('minInputTime', {
                                    initialValue: filter && filter.minInputTime
                                })(
                                    <DatePicker style={{ width: '100%', minWidth: 'auto' }} format="YYYY-MM-DD HH:mm" showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }} />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={2}>
                            <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                -
                                </span>
                        </Col>
                        <Col span={11}>
                            <FormItem>
                                {getFieldDecorator('maxInputTime', {
                                    initialValue: filter && filter.maxInputTime
                                })(
                                    <DatePicker style={{ width: '100%', minWidth: 'auto' }} format="YYYY-MM-DD HH:mm" showTime={{ defaultValue: moment('23:59:59', 'HH:mm:ss') }} />
                                )}
                            </FormItem>
                        </Col>
                    </FormItem>
                    <FormItem {...formItemLayout} label={`录入方式`}>
                        {getFieldDecorator('inputTypes', {
                            initialValue: filter && filter.inputTypes
                        })(
                            <CheckboxGroup options={inputTypesOption} />
                        )}
                    </FormItem>
                    <FormItem label="勾选状态" {...formItemLayout} >
                        {getFieldDecorator('draftStates', {
                            initialValue: filter && filter.draftStates
                        })(
                            <CheckboxGroup options={draftStatesOption} />
                        )}
                    </FormItem>
                    <Col span={24} className="text-right">
                        <Button className="mr10" onClick={this.handleReset}>清空</Button>
                        <Button type="primary" htmlType="submit">筛选</Button>
                    </Col>
                </Form>
            </div>
        );
    }
    private handleFilter = (e: any) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            this.modulesState.loggingFilter = values;
            this.modulesState.loggingList = [];
            this.modulesState.loggingFields = {
                ...values,
                'minInputTime': values['minInputTime'] && values['minInputTime'].format('YYYY-MM-DD HH:mm:ss'),
                'maxInputTime': values['maxInputTime'] && values['maxInputTime'].format('YYYY-MM-DD HH:mm:ss'),
                'minInvoiceDate': values['minInvoiceDate'] && values['minInvoiceDate'].format('YYYY-MM-DD HH:mm:ss'),
                'maxInvoiceDate': values['maxInvoiceDate'] && values['maxInvoiceDate'].format('YYYY-MM-DD HH:mm:ss'),
                orgFileName: values['orgFileName'] || undefined
            };
            ModulesAction.setModulesState().then(() => {
                this.props.getData();
            });
        });
    }
    private handleReset = () => {
        this.props.form.resetFields();
        this.modulesState.loggingFields = {};
        this.modulesState.loggingFilter = {};
        ModulesAction.setModulesState();
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/UI.AuthLogging.Filter.tsx